import _BackTop from './BackTop';

import './style/index.js';

export type { BackTopProps } from './BackTop';

export const BackTop = _BackTop;

export default BackTop;
